export default __webpack_public_path__ + "static/media/912.8984fb36.jpg";